export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/abduzeedo-c7b467e7b4d21be778c9eb38abf122b4.png";